import React, { useEffect, useState } from 'react';

const TimestampConverter = ({ timestamp }) => {
  const [formattedTime, setFormattedTime] = useState('');

  useEffect(() => {
    const formatTimestamp = () => {
      const date = new Date(timestamp);
      const options = { month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
      const formatted = new Intl.DateTimeFormat('en-US', options).format(date);
      setFormattedTime(formatted);
    };

    formatTimestamp(); // Initial formatting

    const interval = setInterval(formatTimestamp, 1000); // Optional: update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [timestamp]);

  return <div>{formattedTime}</div>;
};

export default TimestampConverter;
